import { Component, Input, OnChanges, OnInit } from '@angular/core'

export interface IBarChartInfo {
  bgColorClass: string
  borderColorClass: string
  size: number
  secondarySize?: number
}

@Component({
  selector: 'mg-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
  standalone: false
})
export class BarChartComponent implements OnInit, OnChanges {
  @Input() info: IBarChartInfo[] = []
  @Input() animatable = true
  sizes: number[]
  secondarySizes: number[]
  isVisible: boolean

  ngOnInit(): void {
    this.sizes = this.info.map(() => 0)
    this.secondarySizes = this.info.map(() => 0)
  }

  ngOnChanges(): void {
    this.setSizes()
  }

  setSizes() {
    if (!this.isVisible) {
      return
    }

    setTimeout(() => {
      this.sizes = this.info.map((el) => el.size)
      this.secondarySizes = this.info.map((el) => el.secondarySize ?? 0)
    })
  }
}
